import React, { useContext } from "react";

import { BrandContext } from "../../contexts/BrandContext";
import { ProfileContext } from "../../contexts/ProfileContext";
import SelectorContextProvider, { SelectorContext } from "../../contexts/SelectorContext";
import { LoadingBox } from "./UniversalComponents";


export default function ModeSelector(props){

    const brandContext = useContext(BrandContext);
    const profileContext = useContext(ProfileContext);



    const showLoading = (brandContext.isloading) || (profileContext.isLoading);

    // (brandContext.hasFailed || profileContext.hasFailed)

    if(showLoading){
        return <LoadingBox/>
    }
    return (
        <SelectorContextProvider brandContext={brandContext} profile={profileContext}>
            <SelectorInner>{props.children}</SelectorInner>
        </SelectorContextProvider>
    );
        
}

const SelectorInner = (props) => {
    const {isLoading} = useContext(SelectorContext);
    if(isLoading){
        return <LoadingBox/>
    }
    return props.children;
}